var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"analytics-chart-doughnut"},[(_vm.isEmpty)?_c('div',{staticClass:"message message-info"},[_vm._v("データがありません。")]):_c('div',[_c('chart-doughnut',{ref:"chart",style:(_vm.chartStyles),attrs:{"chart-data":_vm.chartData,"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }